exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".i-editor .dashboard .dashboard-font{line-height:36px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4c77dea2!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/editor/src/modules/font/dashboard.vue
// module id = 472
// module chunks = 0